var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dados)?_c('h3',[_vm._v(_vm._s(_vm.dados.length)+" "+_vm._s(_vm.aba))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }